import http from '@/plugins/axios/axios';

export default class MensagemService {  

    listar(ano, mes) {       
        return http.get('/api/adm/mensagem/listar/'+ano+'/'+mes);
    }

    quantidadeDoDia() {       
        return http.get('/api/adm/mensagem/quantidade-do-dia?fdb=f');
    }
}